import request from '@/utils/request'
const api_name = 'propertyrepair'
export default{
    getAllPropertyRepairs(){
        return request({
            url:`/${api_name}/getallpropertyrepairs`,
            method:'get'
        })
    },
    getPropertyRepairsByPropertyRepair(pojo){
        return request({
            url:`/${api_name}/getpropertyrepairbypropertyrepairsubject`,
            method:'post',
            data:pojo
        })
    },
    addPropertyRepair(pojo){
        return request({
            url:`/${api_name}/addpropertyrepair`,
            method:'post',
            data:pojo
        })
    },
    updatePropertyRepair(pojo){
        return request({
            url:`/${api_name}/updatepropertyrepair`,
            method:'post',
            data:pojo
        })
    },
    deletePropertyRepair(id){
        return request({
            url:`/${api_name}/deletepropertyrepair?id=`+id,
            method:'post',
        })
    },
    
}







